import { createFileRoute } from '@tanstack/react-router'
import { DesaInfoManager } from '../../../../components/DesaInfoManager'

export const Route = createFileRoute('/desa/$slug/dashboard/informasi')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <DesaInfoManager desaId={desaId} />
  },
})
